import { saveAs } from 'file-saver';

export const fetchFileAsBlob = async (input: RequestInfo, init?: RequestInit, reportName?: string) => {
  const res = await fetch(input, init);
  if (res && res.blob) {
    const blob = await res.blob();
    if (blob && blob.type) {
      saveAs(blob, reportName);
    }
  }

  return res;
};
